export default __webpack_public_path__ + "static/media/website.405a0951.svg";